import React, { useEffect, useState } from "react";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { useAppContext } from "../context/AppContext";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { auth } from "../context/AppContext";
import Preloader from "../components/Preloader";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab';


const LoginPage: React.FC = () => {
  //const [isSignUpMode, setIsSignUpMode] = useState(false);
  const { isLoggedIn } = useAppContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [value, setValue] = useState("1");
  // Email/Password inputs
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    document.title = "Login | ipwd.club";
  }, []);

  // If we're already logged in, try to go to Content page
  if (isLoggedIn) {
    return <Navigate to="/files" />;
  }

  // async function handleSubmit() {
  //   try {
  //     if (isSignUpMode) {
  //       // Check password is valid
  //       if (password.length < 6) {
  //         toast.error("Password must be at least 6 characters");
  //         return;
  //       }
  //       // Sign Up flow
  //       setIsSubmitting(true);
  //       await createUserWithEmailAndPassword(auth, email, password);
  //       setIsSubmitting(false);
  //     } else {
  //       // Sign In flow
  //       setIsSubmitting(true);
  //       await signInWithEmailAndPassword(auth, email, password);
  //       setIsSubmitting(false);
  //     }
  //   } catch (err: any) {
  //     console.error("Auth error:", err);
  //     setIsSubmitting(false);
  //     toast.error("Error signing up: " + err.message);
  //   }
  // }
  
  async function handleSignIn() {
    try {
      setIsSubmitting(true);
      await signInWithEmailAndPassword(auth, email, password);
      setIsSubmitting(false);
    } catch (err: any) {
      console.error("Auth error:", err);
      setIsSubmitting(false);
      toast.error("Error signing in: " + err.message);
    }
  }

  async function handleSignUp() {
    try {
      setIsSubmitting(true);
      await createUserWithEmailAndPassword(auth, email, password);
      setIsSubmitting(false);
    } catch (err: any) {
      console.error("Auth error:", err);
      setIsSubmitting(false);
      toast.error("Error signing up: " + err.message);
    }
  }

  const handleForgotPassword = async () => {
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Password reset email sent");
    }
    catch (err: any) {
      console.error("Forgot password error:", err);
      toast.error("Error sending password reset email: " + err.message);
    }
  }

  if (isSubmitting) {
    return <Preloader message="Please wait..." />;
  }

  return (
    <div className="auth-container">
      <h2>Welcome, doll.</h2>

      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList indicatorColor="secondary" onChange={handleChange} className="tab-list">
            <Tab className="tab-button" label="Sign In" value="1" />
            <Tab className="tab-button" label="Sign Up" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" className="auth-form">
            <label>Email:</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />

            <label>Password:</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
            />

            <button className="btn" onClick={handleSignIn}>Login</button>
            <p></p>
            <a onClick={handleForgotPassword}>Forgot Password</a>
        </TabPanel>
        <TabPanel value="2">
          <div className="auth-form">
            <label>Email:</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />

            <label>Password:</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
            />

            <button id="submit" className="btn" onClick={handleSignUp}>Sign Up</button>
            <p></p>
          </div>
        </TabPanel>
      </TabContext>

      {/*

      <div className="auth-form">
        <label>Email:</label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
        />

        <label>Password:</label>
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
        />

        <button className="btn" onClick={handleSubmit}>
          {isSignUpMode ? "Create Account" : "Login"}
        </button>
        <p></p>
      </div> */}

    </div>
  );
}

export default LoginPage;